import React from "react";
import { Helmet } from "react-helmet";
import _ from "lodash";
import { Route } from "react-router-dom";
import { connect } from "react-redux";
import styled from "styled-components";
import Fuse from "fuse.js";

import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import Chip from "@material-ui/core/Chip";

import AddIcon from "@material-ui/icons/Add";

import ProjectTableRow from "../../components/ProjectTableRow";
import PageHeader from "../../components/PageHeader";
import CreateDocButton from "../../components/CreateDocButton";

import { db } from "../../../engine";

import DetailScreen from "./detail";

import * as Color from "../../../components/Color";

const fuseOptions = {
  shouldSort: true,
  threshold: 0.2,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: ["title.en", "title.th"],
};

// const filterItems = (items, inputValue) => {
//   const fuse = new Fuse(items, fuseOptions);
//   const result = fuse.search(inputValue)
//   console.log('filterItems', items, inputValue, result)
//   return _.sortBy(fuse.search(inputValue), item => item.id);
// }

const SearchContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Input = styled.input`
  flex: 0 1 50%;
  margin-right: 10px;

  box-sizing: border-box;
  padding: 8px 12px;
  display: block;
  border-radius: 100px;
  background: white;
  border: 1px solid #d9d9d9;
  outline: none;
  font-size: 14px;

  &:focus {
    border-color: ${Color.primary};
  }
`;

const mapStateToProps = (state) => {
  const projectArray = _.map(
    _.get(state, "newProjects.fullProjects", {}),
    (project, projectId) => {
      return {
        ...project,
        id: projectId,
      };
    }
  );
  return {
    projects: projectArray,
    projectIds: _.map(_.get(state, "newProjects.fullProjects", {}), (project) =>
      _.get(project, "id")
    ),
  };
};

export default connect(mapStateToProps)(
  class extends React.Component {
    state = {
      selectedItem: "",
      page: 0,
      rowsPerPage: 10,
    };

    handleSelectProject = (projectId) => {
      const { history } = this.props;
      history.push(`/admin/projects/${projectId}`);
    };

    handleCreate = (values) => {
      const { title } = values;
      const id = _.kebabCase(`${title}`);

      const docRef = db.collection("projects").doc(id);
      docRef
        .set({
          title: {
            en: title,
          },
        })
        .then(() => {
          const { match, history } = this.props;
          history.push(`${match.url}/${id}`);
        });
    };

    handleDeleteProject = (docRefId) => {
      this.props.dispatch({
        type: "ENTITIES/PROJECTS/DELETE",
        id: docRefId,
      });
    };

    handleChangePage = (event, page) => {
      this.setState({ page });
    };

    handleChangeRowsPerPage = (event) => {
      this.setState({ rowsPerPage: event.target.value });
    };

    handleSearchInputChange = (e) => {
      this.setState({
        searchKeyword: e.target.value,
      });
    };

    handleUpdateProject = (docRefId, fieldValues) => {
      const { projects } = this.props;
      // console.log('handleUpdateProject', { docRefId, fieldValues })
      const project = _.find(
        projects,
        (project) => _.get(project, "id") === docRefId
      );
      /*
      // fieldValues
      capitalGain: "N/A"
      lat: 80
      lon: 0
      rentalPrice: "N/A"
      rentalYield: "N/A"
      salePrice: "10000000"
      startingPrice: NaN
      theAgentProjectCode: "12345"
      theAgentProjectId: "A213A"
      theAgentProjectLink: "test"
      title: "CYBIQ Ramkhamhaeng"
      titleTH: ""
      yearComplete: "2021"
      yearLaunch: "2019"
    */

      this.props.dispatch({
        type: "ENTITIES/PROJECTS/UPDATE",
        id: docRefId,
        data: {
          ...project,
          current: {
            capitalGain: _.get(
              fieldValues,
              "capitalGain",
              _.get(project, "capitalGain", "N/A")
            ),
            rentalPrice: _.get(
              fieldValues,
              "rentalPrice",
              _.get(project, "rentalPrice", "N/A")
            ),
            rentalYield: _.get(
              fieldValues,
              "rentalYield",
              _.get(project, "rentalYield", "N/A")
            ),
            salePrice: _.get(
              fieldValues,
              "salePrice",
              _.get(project, "salePrice", "N/A")
            ),
          },
          title: {
            th: _.get(fieldValues, "titleTH", _.get(project, "title.th", "")),
            en: _.get(fieldValues, "title", _.get(project, "title.en", "")),
          },
          integrations: {
            TheAgent: {
              ProjectCode: _.get(
                fieldValues,
                "theAgentProjectCode",
                _.get(project, "integrations.TheAgent.theAgentProjectCode", "")
              ),
              ProjectID: _.get(
                fieldValues,
                "theAgentProjectId",
                _.get(project, "integrations.TheAgent.ProjectID", "")
              ),
              ProjectLink: _.get(
                fieldValues,
                "theAgentProjectLink",
                _.get(project, "integrations.TheAgent.ProjectLink", "")
              ),
            },
          },
          location: {
            position: {
              _lat: _.get(
                fieldValues,
                "lat",
                _.get(project, "location.position._lat", 0)
              ),
              _lng: _.get(
                fieldValues,
                "lon",
                _.get(project, "location.position._lng", 0)
              ),
            },
          },
          currentPriceSqm: _.get(
            fieldValues,
            "currentPriceSqm",
            _.get(project, "currentPriceSqm", "N/A")
          ),
          startingPrice: _.get(
            fieldValues,
            "startingPrice",
            _.get(project, "startingPrice", "N/A")
          ),
          stock: _.get(fieldValues, "stock", _.get(project, "stock", 0)),
          yearComplete: _.get(
            fieldValues,
            "yearComplete",
            _.get(project, "yearComplete", "")
          ),
          yearLaunch: _.get(
            fieldValues,
            "yearLaunch",
            _.get(project, "yearLaunch", "")
          ),
        },
      });
    };

    filterProjects = () => {
      const { searchKeyword } = this.state;
      const { projects } = this.props;
      if (_.isEmpty(searchKeyword)) return projects;
      const fuse = new Fuse(projects, fuseOptions);
      return _.sortBy(fuse.search(searchKeyword), (item) => item.id);
    };

    render() {
      const { match, history, projectIds } = this.props;
      const listScreenUrl = match.url;
      const { rowsPerPage, page } = this.state;

      const filterProjects = this.filterProjects();
      const visibleIds = _.map(filterProjects, (project) =>
        _.get(project, "id")
      ).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

      return (
        <div>
          <Helmet>
            <title>Projects | MI Treasure</title>
          </Helmet>
          <PageHeader
            title="Projects"
            renderActionButtons={() => (
              <CreateDocButton
                label="Project"
                fields={[
                  {
                    type: "TextField",
                    name: "title",
                    label: "Title",
                    required: true,
                  },
                ]}
                renderButton={() => (
                  <Button variant="extendedFab" color="primary">
                    <AddIcon /> Add Project
                  </Button>
                )}
                onCreate={this.handleCreate}
              />
            )}
          />
          <SearchContainer>
            <Input
              onChange={this.handleSearchInputChange}
              placeholder="Search by project keyword..."
            />
            <Chip
              color="default"
              label={`found ${_.size(filterProjects)} projects`}
            />
          </SearchContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Title</TableCell>
                <TableCell>Code</TableCell>
                <TableCell>Sale</TableCell>
                <TableCell>Rent</TableCell>
                <TableCell>TheAgent</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {_.map(visibleIds, (projectId, index) => (
                <ProjectTableRow
                  key={`${projectId}-${index}`}
                  id={projectId}
                  onClick={(e) => this.handleSelectProject(projectId)}
                />
              ))}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={projectIds.length}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              "aria-label": "Previous Page",
            }}
            nextIconButtonProps={{
              "aria-label": "Next Page",
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
          <Route
            path={`${match.url}/:projectId`}
            children={({ match, ...rest }) => {
              const projectId = _.get(match, "params.projectId");
              // console.log('projectId', projectId);
              const docRef = !_.isEmpty(projectId)
                ? db.collection("projects").doc(projectId)
                : null;
              const open = projectId !== undefined;
              return (
                <Drawer
                  anchor="right"
                  open={open}
                  onClose={() => history.push(listScreenUrl)}
                >
                  <DetailScreen
                    width="700px"
                    {...rest}
                    projectId={projectId}
                    docRef={docRef}
                    onSave={this.handleUpdateProject}
                    onClose={() => history.push(listScreenUrl)}
                    onDelete={this.handleDeleteProject}
                  />
                </Drawer>
              );
            }}
          />
        </div>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/admin/screens/Project/index.js